import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { PrefsProvider } from "./context/PrefsContext";
import { ContentProvider } from "./context/ContentContext";
import Home from "./pages/Home";
import TentangKami from "./pages/TentangKami";
import PasukanKami from "./pages/PasukanKami";
import Perkhidmatan from "./pages/Perkhidmatan";
import Galeri from "./pages/Galeri";
import Hubungi from "./pages/Hubungi";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, checkSession } = useAuth();
  useEffect(() => {
    checkSession();
  }, [checkSession]);
  if (user === null)
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center text-slate-400">
        Memuatkan...
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <PrefsProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/tentang-kami" element={<TentangKami />} />
              <Route path="/pasukan-kami" element={<PasukanKami />} />
              <Route path="/perkhidmatan" element={<Perkhidmatan />} />
              <Route path="/galeri" element={<Galeri />} />
              <Route path="/hubungi" element={<Hubungi />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </PrefsProvider>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
